export class SimulatorModuleConfig{


    private name: string;
    private value: string;
    private parameter: any;
    private state : any;
    private available : boolean = false;

    constructor(data?:any){
        if(data==null || data == undefined){
            return;
        }
        if(data['name']){
            this.name = data['name'];
        }
        if(data['value']){
            this.setValue(data['value']);
        }
        if(data['parameter']){
            this.parameter = data['parameter'];
        }

        return this;
    }

    setAvailable(b:boolean){
        this.available = b;
        return this;
    }
    isAvailable(){
        return this.available;
    }
    setState(state:any){
        this.state = state;
        return this;
    }
    getState(){
        return this.state;
    }
    toString(){
        return '{"name":"'+this.name+'", "value":"'+this.value+'", "parameter":"'+this.parameter+'", "available":'+(this.available?"true":"false")+'}';
    }

    getName(){
        return this.name;
    }
    
    setName(name: string){
        this.name = name;
        return this;
    }
    
    setValue(val:string){
        this.value = val;
        return this;
    }
    
    getValue(){
        return this.value;

    }

    setParameter(val: any){
        this.parameter = val;
        return this;
    }

    getParameter(){
        return this.parameter;
    }


}